import { useSiteContent } from '@/context/SiteContentContext';
import { useTheme } from '@/context/ThemeContext';
import { useBadgeVisibility } from '@/context/BadgeVisibilityContext';

export default function TestimonialsSection() {
  const { content } = useSiteContent();
  const { testimonials } = content;
  const { theme } = useTheme();
  const { settings } = useBadgeVisibility();
  const light = theme === 'light';

  const bg = light ? 'bg-gray-50' : 'bg-[#111D2B]';
  const cardBg = light ? 'bg-white border border-gray-200' : 'bg-[#1C2B3A]';
  const headingColor = light ? 'text-gray-900' : 'text-white';
  const mutedHeading = light ? 'text-gray-400' : 'text-white/60';
  const nameColor = light ? 'text-gray-900' : 'text-white';
  const roleColor = light ? 'text-gray-400' : 'text-white/40';
  const quoteColor = light ? 'text-gray-600' : 'text-white/60';

  return (
    <section className={`${bg} w-full py-20 transition-colors duration-300`}>
      <div className="w-full px-6 md:px-10">
        <div className="mb-12">
          {settings.testimonialsBadge && (
            <span
              className="inline-block text-xs font-bold tracking-widest uppercase px-4 py-1.5 rounded-full mb-4"
              style={{ backgroundColor: 'color-mix(in srgb, var(--accent) 20%, transparent)', border: '1px solid color-mix(in srgb, var(--accent) 40%, transparent)', color: 'var(--accent)' }}
            >
              Testimonials
            </span>
          )}
          <h2 className={`text-4xl md:text-5xl font-black ${headingColor} leading-tight`}>
            Trusted by Boaters<br />
            <span className={mutedHeading}>Around the World.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {testimonials.map((t, i) => (
            <div key={i} className={`${cardBg} rounded-lg p-6 border-t-2`} style={{ borderTopColor: 'var(--accent)' }}>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full text-white font-black text-sm shrink-0" style={{ backgroundColor: 'var(--accent)' }}>
                  {t.initials}
                </div>
                <div>
                  <p className={`${nameColor} font-bold text-sm`}>{t.name}</p>
                  <p className={`${roleColor} text-xs`}>{t.role}</p>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3">
                {[...Array(5)].map((_, si) => (
                  <i key={si} className="ri-star-fill text-xs" style={{ color: 'var(--accent)' }}></i>
                ))}
              </div>
              <p className={`${quoteColor} text-sm leading-relaxed italic`}>&ldquo;{t.text}&rdquo;</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
